// extracted by css-extract-rspack-plugin
export default {"installableAppCardList":"installableAppCardList__g2on6"};